import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordRouteComponent } from './-ForgotPasswordRouteComponent';

/** 재설정 메일의 버튼이 `?token=` 을 달고 들어온다 — 재설정 단계에서 바로 시작한다 */
export const Route = createFileRoute('/forgot-password')({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === 'string' && search.token ? search.token : undefined,
  }),
  component: ForgotPasswordRouteComponent,
});
